/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, FC } from 'react';
import dynamic from 'next/dynamic';
import { RENTAL_WIDGET } from 'lib/utils/mainWidgetConstants';
import {  useSelector } from 'redux/app/store';
import { NewMainWidgetForCrawlers } from 'views/rebranded-module/common/components/UI/NewMainWidgetForCrawlers';

const NewMainWidget = dynamic(() => import('views/rebranded-module/common/components/UI/NewMainWidget/NewMainWidget').then(
  (file) => file.NewMainWidget,
));

type WidgetInfo = {
  type: any;
};
interface NewMainWidgetWrapperProps {
  widgetType?: string;
  whiteLabelWidget?: any;
  vertical?: boolean;
  bordered?: boolean;
  reservationData?: any;
  renderFullWidgetByForce?: boolean;
  shouldHideTitle?: boolean;
  children?: React.ReactNode;
  isDealWidget?: boolean;
  actionButtonCustomLabel?: string;
  rentalWidgetInitData?: any;
  disabled?: boolean;
  firstCallParams?: any;
  showStartYourAdventureLabel?: boolean;
}


const NewMainWidgetWrapper:FC<NewMainWidgetWrapperProps> = (props:any) => {
  const { widgetType, whiteLabelWidget } = props;
  const [widgetInfo, setWidgetInfo] = useState<WidgetInfo>({
    type: widgetType || RENTAL_WIDGET,
  });
  const isCrawler = useSelector((state) => state.globalData.isCrawler);
  // eslint-disable-next-line no-shadow
  const handleWidgetTypeSelect = (widgetType) => {
    setWidgetInfo({ type: widgetType });
  };
  return (
    <>
      {isCrawler ? (
        <NewMainWidgetForCrawlers
          {...props}
          widgetInfo={widgetInfo}
          handleWidgetTypeSelect={handleWidgetTypeSelect}
          whiteLabelWidget={whiteLabelWidget}
          vertical
        />
      ) : (
        <NewMainWidget
          widgetInfo={widgetInfo}
          handleWidgetTypeSelect={handleWidgetTypeSelect}
          whiteLabelWidget={whiteLabelWidget}
          {...props}
        />
      )}
    </>
  );
};

export { NewMainWidgetWrapper };